exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);
exports.i(require("-!../../../node_modules/css-loader/index.js!antd/dist/antd.css"), "");

// module
exports.push([module.id, ".pick-voucher .title {\n  margin-bottom: 0; }\n\n.pick-voucher .voucher-form {\n  display: flex;\n  align-items: flex-end;\n  padding-top: 1rem; }\n  .pick-voucher .voucher-form .input-field {\n    margin-right: 20%; }\n  .pick-voucher .voucher-form .anticon {\n    margin-right: 0.5rem; }\n  .pick-voucher .voucher-form .button {\n    flex-shrink: 0;\n    min-width: 15rem; }\n\n@media screen and (max-width: 1024px) {\n  .pick-voucher .voucher-form .input-field {\n    margin-right: 1rem; }\n  .pick-voucher .voucher-form .anticon {\n    display: none; }\n  .pick-voucher .voucher-form .button {\n    padding: 1rem;\n    min-width: 10rem; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/PickVoucher/PickVoucher.scss
// module id = 1588
// module chunks = 0